/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-06 14:52.
 */
const BaseCategoryPage = require( 'base/category-page' );
const Server = require( 'helper/server' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

const listTpl = Handlebars.templates[ 'templates/message_center_tpl' ];

class MessageCenter extends BaseCategoryPage {
  constructor() {
    super( {
      events: {
        'click .list__status-item': 'statusChanged',
        'click .message-center-item-view': 'messageDetail'
      }
    } );
    this.isRead = undefined;
  }

  async init() {
    // MessageCenter
    const data = initMenu( 'MessageCenter', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
  }

  search() {
    const requestParams = {
      pageSize: this.pageSize,
      pageNo: this.pageNo,
      isRead: this.isRead
    };
    this.renderTable( requestParams );
  }

  statusChanged( e ) {
    const el = e.target || e.srcElement;
    const $el = $( el );
    if ($el.hasClass( 'selected' )) {
      return false;
    }
    const { status = - 1 } = $el.data();
    this.isRead = status === - 1 ? undefined : status == 2;
    $el.addClass( 'selected' ).siblings().removeClass( 'selected' );
    this.pageSize = 15;
    this.pageNo = 1;
    this.search();
  }

  async renderTable( requestParams ) {
    const spiner = this.$el.find( '.block__content' ).spin();
    try {
      const { data = [], total = 0 } = await Server.getMessageList( requestParams );
      const html = listTpl( {
        _DATA_: data,
        _TOTAL_: total,
        _pageSize_: this.pageSize
      } );
      this.$el.find( '.block__content' ).html( html );
      this.$el.find( '.block__content .total' ).text( total || 0 );
      this.initPagination( total || 0 );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
    spiner.stop();
  }

  messageDetail( e ) {
    const el = e.target || e.srcElement;
    const isRead = $( el ).parents( 'td' ).find( 'input' ).val() == '1';
    const id = $( el ).data( 'id' );
    if (isRead) {
      window.open( `/member/message-detail.html?messageid=${ id }` );
    } else {
      Server.setMessageReaded( { messageId: id } ).then( () => {
        this.search();
        window.open( `/member/message-detail.html?messageid=${ id }` );
      } );
    }
  }
}

module.exports = MessageCenter;
